/**
 * Why a card was not held for the deposit, in the counter's words.
 *
 * The code is Stripe's: the payment error's `decline_code`, else its `code`,
 * else the PaymentIntent's cancellation reason (server: deposits.ts). The
 * counter needs what to tell the customer and what to try next, not the code,
 * which stays under "Dettagli tecnici" for whoever looks after the system (C5).
 *
 * A card reported lost or stolen, or a payment the bank thinks fraudulent, is
 * said as a plain refusal, like any code not listed here: Stripe asks that the
 * specific reason never reach the customer, who is standing at the counter.
 */
export type DeclineKind = 'funds' | 'expired' | 'pin' | 'temporary' | 'cancelled' | 'declined'

const KINDS: ReadonlyMap<string, DeclineKind> = new Map<string, DeclineKind>([
  ['insufficient_funds', 'funds'],
  ['card_velocity_exceeded', 'funds'],
  ['withdrawal_count_limit_exceeded', 'funds'],
  ['expired_card', 'expired'],
  ['incorrect_pin', 'pin'],
  ['invalid_pin', 'pin'],
  ['offline_pin_required', 'pin'],
  ['online_or_offline_pin_required', 'pin'],
  ['processing_error', 'temporary'],
  ['try_again_later', 'temporary'],
  ['issuer_not_available', 'temporary'],
  ['reenter_transaction', 'temporary'],
  // No card was refused: the attempt was called off (by the counter, the reader or Stripe).
  ['canceled', 'cancelled'],
  ['abandoned', 'cancelled'],
  ['requested_by_customer', 'cancelled'],
  ['duplicate', 'cancelled'],
  ['automatic', 'cancelled'],
])

export function declineKind(code: string | null): DeclineKind {
  return (code === null ? undefined : KINDS.get(code)) ?? 'declined'
}
